import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'

export interface FilterState {
    page?: number | string;
    limit?: number | string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc' | string;

    search?: string;
    competition?: {
        country?: string;
        competition_id?: string;
        club_id?: string;
    };
    nameOptions?: {
        first_name?: string;
        last_name?: string;
        pseudonym?: string;
        full_name?: string;
    };
    personalData?: {
        date_of_birth?: string; // yyyy-mm-dd
        age_min?: number;
        age_max?: number;
        height_min?: number;
        height_max?: number;
        citizenship?: string;
        other_citizenship?: string;
        place_of_birth?: {
            city?: string;
            country?: string;
        }
    },
    playerData?: {
        marketvalue_min?: number;
        marketvalue_max?: number;
        position?: string;
        main_position?: string;
        other_position?: string;
        jersey_number?: string;
        captain?: boolean;
        contract_expiration_year?: number;
        club_nationality?: string;
    }
}

export const normalizeFilterInput = (filters: FilterState) => ({
    ...filters,
    page: filters.page ? Number(filters.page) : undefined,
    limit: filters.limit ? Number(filters.limit) : undefined,
});

export const defaultValues = {
    page: 1,
    limit: 50,
    playerData: {
        marketvalue_min: 0,
        marketvalue_max: 200000000,
    }
}
    

const FilterProvider = ({ children }: { children: React.ReactNode }) => {
    const form = useForm<FilterState>({
        defaultValues: defaultValues
    })

    return (
        <FormProvider {...form}>
            {children}
        </FormProvider>
    )
}

export default FilterProvider